import { inviteUsers } from "api/services/user-service";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";

export const useInviteUser = () => {
    const { callAPI, loading } = useWorkspaceApiCall(inviteUsers, 'inviteUser.success', 'inviteUser.error');

    return { inviteUser: callAPI, invitingUser: loading };
}